export var getStyles = function (props) {
    var theme = props.theme;
    return {
        root: {
            margin: '14px 24px 20px 24px',
            flexGrow: 1
        },
        accessibleCloseButton: {
            position: 'absolute',
            fontSize: '20px',
            width: '44px',
            height: '40px',
            right: 0,
            marginRight: '0 !important',
            zIndex: '1',
            top: '-100px',
            selectors: {
                '&:focus, &:focus:hover': {
                    color: theme.palette.neutralPrimary,
                    top: 0
                }
            }
        }
    };
};
//# sourceMappingURL=CoherencePanelBody.styles.js.map